(() => {
  const configuration = document.getElementById('np-lead-time-settings');
  if (!configuration) return;
  const settings = JSON.parse(configuration.textContent);
  const root = window.Shopify?.routes?.root || '/';
  let synchronization;

  const pendingRows = () => [...document.querySelectorAll('[data-np-lead-time-key]')]
    .filter((element) => element.dataset.npLeadTimeSynced !== 'true');

  const synchronize = () => {
    if (synchronization) return synchronization;
    const desired = new Map(pendingRows().map((element) => [
      element.dataset.npLeadTimeKey, element.dataset.npLeadTimeValue,
    ]));
    if (!desired.size) return Promise.resolve(false);

    synchronization = (async () => {
      const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Unable to read cart delivery details.');
      let cart = await response.json();
      let changed = false;
      for (const [key, value] of desired) {
        const item = cart.items.find((line) => line.key === key);
        if (!item || item.properties?.['Lead time'] === value) continue;
        const update = await fetch(`${root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            id: item.key,
            quantity: item.quantity,
            properties: { ...item.properties, 'Lead time': value },
          }),
        });
        if (!update.ok) throw new Error('Unable to save cart delivery details.');
        cart = await update.json();
        changed = true;
      }
      return changed;
    })().finally(() => { synchronization = undefined; });
    return synchronization;
  };

  const showError = () => {
    document.querySelectorAll('[data-np-lead-time-status]').forEach((status) => {
      status.hidden = false;
      status.textContent = 'Please refresh the page to update delivery details before checkout.';
    });
  };

  // A previous retail deposit cart is converted by the Trade payment script first.
  // Its reload will then run delivery synchronization against the new line keys.
  const tradePlans = document.getElementById('np-trade-fullpay-cart');
  if (tradePlans && JSON.parse(tradePlans.textContent).length) return;

  if (settings.cartPage && pendingRows().length) {
    synchronize().then(() => window.location.reload()).catch(showError);
  }

  // Quick-add and older carts can arrive without product form properties.
  // Save those details before native checkout or WPD's normal /cart handoff.
  document.addEventListener('click', async (event) => {
    const trigger = event.target.closest('button[name="checkout"], input[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"]');
    if (!trigger || !pendingRows().length) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if ('disabled' in trigger) trigger.disabled = true;
    try {
      await synchronize();
      window.location.assign(`${root}${settings.trade ? 'cart' : 'checkout'}`);
    } catch {
      if ('disabled' in trigger) trigger.disabled = false;
      showError();
    }
  }, true);
})();
